import { render, staticRenderFns } from "./inputPassword.vue?vue&type=template&id=18aeb05f&scoped=true&"
import script from "./inputPassword.vue?vue&type=script&lang=ts&"
export * from "./inputPassword.vue?vue&type=script&lang=ts&"
import style0 from "./inputPassword.vue?vue&type=style&index=0&id=18aeb05f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aeb05f",
  null
  
)

export default component.exports